import React from 'react';
import { Button } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './style';
import parse from 'html-react-parser';

export const DoubleButton = (props: {
  onClick1: () => void;
  onClick2: () => void;
  content1: string;
  content2: string;
}) => {
  const classes = useStyles();
  return (
    <div
      className={clsx(
        classes.textSectionWrapper,
        classes.doubleButtonContainer
      )}>
      <Button onClick={props.onClick1} className={classes.CTAButton}>
        {parse(props.content1)}
      </Button>
      <Button onClick={props.onClick2} className={classes.CTAButton}>
        {parse(props.content2)}
      </Button>
    </div>
  );
};
